// extracted by mini-css-extract-plugin
export default {"ReviewsInProgressListContainer":"ReviewsInProgressList_ReviewsInProgressListContainer__GY-80"};